"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  numeral: "1",
  title: "Send your nameplate schedule or utility standard",
  description: "An equipment list, your utility's nameplate format, or a file (DXF, DWG, AI, PDF, SVG); or a marked-up drawing."
}, {
  numeral: "2",
  title: "Get a quote",
  description: "Materials matched to placement, sizes, mounting, quantity pricing, and lead time."
}, {
  numeral: "3",
  title: "Approve the proof",
  description: "Confirm nameplate data, ratings, and warning content in writing before engraving."
}, {
  numeral: "4",
  title: "Production & ship",
  description: "Engraved on weather-rated materials and shipped install-ready, with approved formats stored for reorders."
}];
export default function HowToOrder() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="how-to-order" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-20">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
            How Do You Order Utility Nameplates and Signs?
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Ordering substation and plant identification from Evermark Industrial
            Solutions takes four steps, built around your nameplate schedule or
            utility standard and a proof.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 lg:gap-12 mb-16 md:mb-20">
          {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center md:items-start md:text-left group">
              <div className="mb-6 relative">
                <span className="font-default text-7xl md:text-8xl font-bold text-primary/20 absolute -top-4 -left-4 md:-left-6 select-none transition-colors duration-300 group-hover:text-primary/30">
                  {step.numeral}
                </span>
                <span className="font-default text-5xl md:text-6xl font-bold text-primary relative z-10">
                  {step.numeral}
                </span>
              </div>
              <h3 className="font-default text-xl md:text-2xl font-semibold text-foreground mb-4 leading-tight">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Link to="/ContactPage">
            <Button size="lg" className="text-base px-8 h-14 font-semibold">
              Request a Quote
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}